/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React, { useEffect, useState } from 'react';
import * as customersCrud from "../../../../../app/modules/App/_redux/customers/customersCrud"
//import { useHistory } from "react-router-dom";
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


export function QuickUser() {

  const [loading, setLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  let [userRequests, setuserRequests] = useState([])
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);


  const loadResult = async () => {
    let startDateTimeStamp;
    let endDateTimeStamp;
    if (startDate && endDate) {
      startDateTimeStamp = new Date(moment(startDate).startOf('day')).getTime()
      endDateTimeStamp = new Date(moment(endDate).endOf('day')).getTime()
    }
    let response = await customersCrud.getApprovalRequest(startDateTimeStamp, endDateTimeStamp)
    let item = response?.data?.data;
    const approvalCount = response?.data?.count;
    if(approvalCount!==undefined){
      window.approvalCount = approvalCount;
    }
    if(item) setuserRequests(item);
    setLoading(false)
  }

  useEffect(()=>{
    setLoading(true)
    let intervalId = 1;
    const fetchData = async ()=>{
      try {
        await loadResult();
      } catch (error) {
      } finally {
        if(intervalId){
          intervalId = setTimeout(fetchData, 5000);
        }
      }
    }
    fetchData();
    return ()=> {
      clearTimeout(intervalId);
      intervalId = null;
    }
  }, []);

  const resetFilter = async () => {
    setStartDate(0)
    setEndDate(0)
    let response = await customersCrud.getApprovalRequest(undefined, undefined)
    let item = response.data.data
    setuserRequests(item);
    setLoading(false)
  }

  const exportRequestData = async () => {
    let startDateTimeStamp;
    let endDateTimeStamp;
    if (startDate && endDate) {
      startDateTimeStamp = new Date(startDate).getTime() / 1000
      endDateTimeStamp = new Date(endDate).getTime() / 1000
    }
    await customersCrud.exportRequestData(startDateTimeStamp, endDateTimeStamp)
  }

  const handleRequest = async (id, status, index) => {
    setSubmitting(true)
    setLoading(true)
    //Resetting values 
    let userRequestsData = [];
    var cvObj;
    for (let i = 0; i < userRequests.length; i++) {
      cvObj = userRequests[i];
      if (cvObj.id !== id) {
        userRequestsData.push(cvObj)
      }
    }
    setuserRequests(userRequestsData)
    await customersCrud.ApproveRequests(id, { "req_status": status })
    setSubmitting(false)
    setLoading(false)
  }

  const formateTime = (currentTimestamp) => {
    return moment(currentTimestamp).format("D MMM YYYY HH:mm A");
  }

  return (
    <div id="kt_quick_user" className="offcanvas offcanvas-right offcanvas p-10">
      <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
        <h3 className="font-weight-bold m-0">
          Approval Request
            {/* <small className="text-muted font-size-sm ml-2">12 messages</small> */}
        </h3>
        <a
          href="#"
          className="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i className="ki ki-close icon-xs text-muted" />
        </a>
      </div>

      <div className="form-group row ">
        <div className="col-lg-12 align-items-center d-flex justify-content-between">
          <label className="pr-4">Start Date</label>
          <DatePicker selected={startDate} dateFormat="MM/dd/yyyy" onChange={(date) => setStartDate(date)} className="float-right" />
        </div>

        <div className="col-lg-12 align-items-center d-flex justify-content-between" >
          <label className="pr-5">End Date</label>
          <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} className="float-right" />
        </div>
        <div className="col-lg-12 d-flex align-items-start flex-column justify-content-between">
          <div className="d-flex justify-content-between w-100">
            <button className="btn btn-success btn-sm mr-3 mb-3 " onClick={() => loadResult()}>Search</button>
            <button className="btn btn-success btn-sm mb-3 " onClick={() => resetFilter()}>Reset Filter</button>
          </div>
          <button style={{ minWidth: "150px", float: "right" }} disabled={userRequests.length > 0 ? false : true } className="btn btn-primary" onClick={() => exportRequestData()} >Export To CSV</button>
        </div>
      </div>

      {
        loading ? <i className="fa fa-spinner"></i>
          :
          <>
            {
              loading ? <i className="fa fa-spinner"></i> :
                <>
                  {
                    userRequests.length > 0 ?
                      <>
                        {userRequests.map((a, index) => (
                          <div key={index} id={index} className="d-flex align-items-center userRequestDiv">
                            <div className="d-flex flex-column">
                              <a href="#" className="font-weight-bold font-size-h5 text-dark-75 text-hover-primary" > {a.sensor_name} </a>
                              <p className="mb-2">ID: {a.sensor_id}</p>
                              <p className="mb-2">Topic: {a.sensor_id}/{a.variable}</p>
                              <p className="mb-2">Payload: {a.variable_value}</p>
                              <p className="mb-2">DateTime: {formateTime(a.request_date)} </p>
                              <p className="mb-2">User: {a.user_name} ({a.email}) </p>
                              <div className="form-group row mb-0">
                                <div className="col-12">
                                  {submitting ? <i className="fa fa-spinner"></i> :
                                    <>
                                      <button className="btn btn-success btn-sm mr-3 mb-3 col-5" onClick={() => handleRequest(a.id, "Accepted", index)} >Approve</button>
                                      <button className="btn btn-outline-danger  mb-3 btn-sm col-6" onClick={() => handleRequest(a.id, "Rejected", index)} >Reject</button>
                                    </>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                      :
                      <div className="offcanvas-content pr-5 mr-n5" >
                        <div className="d-flex align-items-center userRequestDiv">
                          <div className="d-flex flex-column">
                            No approval requests found yet
                </div>
                        </div>
                      </div>
                  }
                </>
            }

          </>
      }
    </div>
  );
}
